import React from 'react'
import Author from '../Author'
import SocialShare from '../SocialShare'
import * as Styled from './AuthorLine.styles'

const AuthorLine = ({ publishDate, firstName, lastName, authorLink }) => (
  <Styled.AuthorLine>
    <Author
      publishDate={publishDate}
      firstName={firstName}
      lastName={lastName}
      authorLink={authorLink}
    />
    <SocialShare />
  </Styled.AuthorLine>
)

export default AuthorLine
